export default "__VITE_ASSET__D1dthnxc__"